import { QUERY_KEYS } from 'api/query-keys';
import { partnerWorkerService } from 'api/services';
import { PartnerWorkerProfile } from 'api/services/partner-worker/partner-worker-profile.schema';
import { useQuery } from 'react-query';
import { CACHE_TIME_LONG } from 'shared/react-query/query-defaults';

export const useGetPartnerWorkerProfile = (workerId: string = '') => {
  const queryFn = async () => await partnerWorkerService.getPartnerWorkerProfile(workerId);

  return useQuery<Promise<PartnerWorkerProfile>, Error, PartnerWorkerProfile>(
    QUERY_KEYS.partnerWorkerProfile(workerId),
    queryFn,
    {
      enabled: workerId.length > 0,
      cacheTime: CACHE_TIME_LONG,
    }
  );
};
